import { combineReducers } from 'redux';
import cardProduct from './card-product.reducer';
import cardSchema from './card-schema.reducer';
import cardLimit from './card-limit.reducer';
import card from './card.reducer';
import cardFreezeRequest from './card-freeze-request.reducer';
import cardUnfreezeRequest from './card-unfreeze-request.reducer';
import cardRestriction from './card-restriction.reducer';
import cmsAccount from './cms-account.reducer';
import cardReplacementRequest from './card-replacement-request.reducer';
const cmsRootReducer = combineReducers({
    cardProduct,
    cardSchema,
    cardLimit,
    card,
    cardFreezeRequest,
    cardUnfreezeRequest,
    cardRestriction,
    cmsAccount,
    cardReplacementRequest,
});
export default cmsRootReducer;
